/* Imports */
// Library
import { select } from 'd3'
// Local

import './style.scss';
import CardWrapper from '../CardWrapper/cardWrapper';


export default class SlideChart {
  constructor(data) {
    this.data = data
    this.selection = select('#slide-chart')
  }

  /* Things that only happen once */
  init() {

    this.wrapper = new CardWrapper(this.selection, this.data)
    this.cards = this.wrapper.cardArray

  }

}